import { useRef } from 'react'
import { /*Badge,*/ Body, Box, ElementHighlight, Expertise, H4 } from '../widgets'
import { GuidanceButton } from '.'
import { padZero } from '../../utilities.js'

export const PracticeResults = ({ value, change, touches, timeTaken, onGuidanceClick, displayMode }) => {
  const improveButton = useRef()

  return (
    <>
      <Box column fullWidth gap={32} alignItems="center">
        <Box column alignItems="center" gap={24}>
          <H4 align="center">TOTAL SCORE</H4>
          <Box column gap={4}>
            <Expertise value={value} change={change} valueSize={120} />
          </Box>
          {/*<Badge rank={20} mode="subset" />*/}
        </Box>

        {touches > 0 &&
          <Box column gap={12} alignItems="center" width={330}>
            <Body alt bold>CONSENSUS MODE</Body>
            <Box fullWidth>
              <Box column alignItems="center" width="50%" gap={8}>
                <Body alt bold color="#727272" align="center" size={16}>Touches</Body>
                <H4>{touches}</H4>
              </Box>
              <Box column alignItems="center" width="50%" gap={8}>
                <Body alt bold color="#727272" align="center" size={16}>Decision time</Body>
                <H4>{Math.floor(timeTaken / 1000 / 60)}:{padZero(Math.floor(timeTaken / 1000 % 60))}</H4>
              </Box>
            </Box>
          </Box>
        }

        {!displayMode &&
          <GuidanceButton onClick={onGuidanceClick} ref={improveButton} />
        }
      </Box>

      <ElementHighlight
        order={6}
        target={improveButton}
        pointDirection="right-down"
        nextOnFinish
      />
    </>
  )
}